module.exports = __webpack_public_path__ + "static/media/hero-bcg.1f293b1b.jpeg";